import type { MasterDataState } from './support.types';

export const createInitialMasterState = <
  TData = unknown,
>(): MasterDataState<TData> => ({
  data: [],
  loading: false,
  error: null,
});
